module.exports = __webpack_public_path__ + "static/media/notext_logo.1ec71785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notext_logo.svg
// module id = 82
// module chunks = 0